import { Component, OnInit } from '@angular/core';
import {Grupa} from "../../services/grupa";
import {ActivatedRoute} from "@angular/router";
import {KursanciService} from "../../services/kursanci.service";

@Component({
  selector: 'app-grupa-details',
  templateUrl: './grupa-details.component.html',
  styleUrls: ['./grupa-details.component.scss']
})
export class GrupaDetailsComponent {

    grupa: Grupa;

    constructor( private route: ActivatedRoute, private kursanciService: KursanciService ) {

        route.data
        // .do(res => console.log('route.data:', res))
            .subscribe(
                data => this.grupa = data['grupa']
            );
    }

    save(json) {

        this.kursanciService.zapiszGrupe(this.grupa.key, json)
            .subscribe(
                () => {
                    alert("Zapisano grupę.");
                },
                err => alert(`Błąd zapisu danych. ${err}`)
            );

    }

}



// WEBPACK FOOTER //
// ./src/app/grupy/grupa-details/grupa-details.component.ts